import { createTypes, async, asyncActionCreator } from 'redux-action-creator';
import { getWaiverAirlines } from '../../../../service/waiverAirlineService';

export const types: { [key: string]: string } =
  createTypes([...async('LOAD')], 'WAIVER_AIRLINES');

export const fetchWaiverAirlines = asyncActionCreator(
  types.LOAD,
  () => getWaiverAirlines()
);
